import React from "react";
import { View, Text, Pressable, StyleSheet } from "react-native";
import metrics from "@constants/metrics";
import color from "@constants/color";
import t from "@constants/localization";

const PATH = "screens/MyTask";

function CancelRescheduleModal({ markingAction, setRescheduledModal }) {
  return (
    <View style={styles.centeredModal}>
      <View>
        <Text style={[styles.bold, { textAlign: "center" }]}>
          {t(`${PATH}/cancel_reschedule`)}
        </Text>
      </View>
      <View style={styles.modalContainer}>
        <Pressable
          style={[
            styles.modalBtns,
            {
              backgroundColor: "rgba(255, 221, 221, 1)",
            },
          ]}
          onPress={async () => {
            await markingAction({
              action: "CLEAR_STATUS",
              reason: "CLEAR_STATUS",
            });
            setRescheduledModal(false);
          }}
        >
          <Text style={styles.bold}>{t(`${PATH}/yes`)}</Text>
        </Pressable>
        <Pressable
          style={[
            styles.modalBtns,
            {
              backgroundColor: "rgba(246, 246, 246, 1)",
            },
          ]}
          onPress={() => setRescheduledModal(false)}
        >
          <Text style={styles.bold}>{t(`${PATH}/no`)}</Text>
        </Pressable>
      </View>
    </View>
  );
}

function MarkRescheduleModal({
  isPendingDMinus2,
  markingAction,
  setRescheduledModal,
  selectedAction,
  taskActionConfig,
}) {
  return (
    <>
      <View style={styles.topRightTip} />
      <View style={styles.topRightContainer}>
        <Text
          style={[
            {
              color: taskActionConfig?.titleColor,
              textAlign: "center",
              marginTop: 6,
            },
            Object.values(taskActionConfig?.actions || {}).length > 0
              ? {
                  fontWeight: "bold",
                  fontSize: 18,
                }
              : {},
          ]}
        >
          {taskActionConfig?.title}
        </Text>
        {taskActionConfig?.actions &&
          Object.values(taskActionConfig?.actions).length > 0 &&
          Object.values(taskActionConfig?.actions).map((action) => (
            <Pressable
              key={action.key}
              style={[styles.topRightBtns]}
              onPress={async () => {
                await markingAction({
                  action: action.action,
                  reason: action.key,
                });
                setRescheduledModal(false);
              }}
            >
              <Text>{action.value2}</Text>
            </Pressable>
          ))}
      </View>
    </>
  );
}

function ModalTransparency({ setRescheduledModal }) {
  return (
    <Pressable
      style={styles.rescheduleModalPress}
      onPress={() => {
        setRescheduledModal(false);
      }}
    >
      <View style={styles.rescheduleModalTransparency} />
    </Pressable>
  );
}

function RescheduleModal({
  rescheduledModal,
  isRescheduled,
  setRescheduledModal,
  isPendingDMinus2,
  markingAction,
  selectedAction,
  taskActionConfig,
}) {
  return rescheduledModal ? (
    <>
      <ModalTransparency setRescheduledModal={setRescheduledModal} />
      {isRescheduled ? (
        <CancelRescheduleModal
          markingAction={markingAction}
          setRescheduledModal={setRescheduledModal}
        />
      ) : (
        <MarkRescheduleModal
          isPendingDMinus2={isPendingDMinus2}
          markingAction={markingAction}
          selectedAction={selectedAction}
          setRescheduledModal={setRescheduledModal}
          taskActionConfig={taskActionConfig}
        />
      )}
    </>
  ) : null;
}

export default RescheduleModal;

const styles = StyleSheet.create({
  centeredModal: {
    position: "absolute",
    zIndex: 10,
    width: metrics.screenWidth - 100,
    left: 50,
    top: metrics.screenHeight / 2 - 170,
    backgroundColor: color.white,
    padding: 20,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    marginTop: 10,
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-evenly",
  },
  modalBtns: {
    paddingVertical: 8,
    paddingBottom: 10,
    paddingHorizontal: 30,
    borderRadius: 20,
  },
  selectedBtn: {
    backgroundColor: "rgba(242, 251, 247, 1)",
    borderColor: "rgba(0, 171, 89, 1)",
  },
  selectedText: {
    color: "rgba(0, 171, 89, 1)",
  },
  rescheduleModalPress: {
    position: "absolute",
    zIndex: 5,
    height: "100%",
    width: "100%",
  },
  rescheduleModalTransparency: {
    position: "absolute",
    zIndex: 5,
    backgroundColor: color.borderColor,
    height: "100%",
    width: "100%",
  },
  bold: {
    fontWeight: "bold",
  },
  topRightTip: {
    position: "absolute",
    zIndex: 5,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: color.borderColor2,
    height: 30,
    width: 30,
    right: 40,
    top: -5,
    transform: [{ rotate: "45deg" }],
  },
  topRightContainer: {
    position: "absolute",
    zIndex: 10,
    right: 10,
    top: 10,
    backgroundColor: color.white,
    paddingHorizontal: 10,
    paddingBottom: 10,
    borderRadius: 10,
  },
  topRightBtns: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    marginTop: 10,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: color.borderColor3,
    alignItems: "center",
  },
  disabledBtn: {
    backgroundColor: color.disableGrey,
  },
  disabledFont: {
    color: color.disableFont,
  },
  topRightDM2: {
    alignItems: "center",
  },
  topRightDM2Text: {
    fontSize: 12,
    color: color.red2,
  },
});
